import { render, staticRenderFns } from "./CesiumPlugin.vue?vue&type=template&id=bea80b5a&scoped=true"
import script from "./CesiumPlugin.vue?vue&type=script&lang=ts"
export * from "./CesiumPlugin.vue?vue&type=script&lang=ts"
import style0 from "./CesiumPlugin.vue?vue&type=style&index=0&id=bea80b5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea80b5a",
  null
  
)

export default component.exports